import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTeams } from '../TeamsProvider';
import { PopperHost, PopperProvider } from './PortalPopper';
import classNames from 'classnames';
import { useSelector } from '../hook-utils';
import { shuttingDown } from '../store/reducers/settings';

export default function ToastPortal(props: React.PropsWithChildren<{
  id: string
  toastName: string,
  width: number,
  height: number,
  className: string,
  isQueueCall: boolean,
  isToaster?: boolean,
  onClose?(): void
}>) {

  const { theme } = useTeams()
  const [externalWindow, setExternalWindow] = useState<Window>()
  const winRef = useRef<Window>()
  const shutting = useSelector(shuttingDown)

  useEffect(() => {
    // open a new browser window and store a reference to it
    let win = window.open('', props.isToaster === false ? 'ipfx-window' + props.id : 'ipfx-toast-window' + props.id, 'title=' + (props.toastName ? props.toastName : '') + ',width=' + props.width.toString() + ',height=' + props.height.toString() + ',menubar=1,resizable=0,isQueueCall=' + props.isQueueCall);
    if (win == null) { return }

    win.document.title = props.toastName ? props.toastName : '';
    winRef.current = win

    copyStyles(document, win.document);

    const style = win.document.createElement('style');
    style.appendChild(win.document.createTextNode('.CallPopupContainer {right:0;bottom:0;} '))
    win.document.head.appendChild(style);

    setExternalWindow(win)

    const handleBeforeUnloadEvent = (e: BeforeUnloadEvent) => {
      if (props.onClose)
        props.onClose()
    }

    const handleUnloadEvent = (e: Event) => {
      if (props.onClose)
        props.onClose()
    }

    if (win != null) {
      win.addEventListener('beforeunload', handleBeforeUnloadEvent)
      win.addEventListener('unload', handleUnloadEvent)
    }

    return () => {

      winRef.current = undefined

      //was getting an error from Sharon's PC
      try {
        
        if (win != null) {
          win.removeEventListener('beforeunload', handleBeforeUnloadEvent)
          win.removeEventListener('unload', handleUnloadEvent)
          win.close()
          win = null
        }

      } catch (ex) {
        console.error(ex)
      }

      setExternalWindow(undefined)

      if (props.onClose)
        props.onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.height, props.id, props.width, theme])

  useEffect(() => {
    if (winRef.current) {
      winRef.current.document.title = props.toastName
    }
  }, [props.toastName])

  //close window as shutting down
  useEffect(() => {
    if (shutting === true) {
      if (winRef.current) {

        try {
          winRef.current.close()
        }
        catch (ex) {
          console.error(ex)
        }

      }
    }
  }, [shutting])

  if (externalWindow == null) { return null }

  return ReactDOM.createPortal(
    <div className={classNames('App', `theme-${theme}`)} key={props.id}>
      <PopperProvider>
        <div className={props.className}>{props.children}</div>
        <PopperHost className='menuHost' />
      </PopperProvider>
    </div>, externalWindow.document.body)
}

function copyStyles(sourceDoc: Document, targetDoc: Document) {
  Array.from(sourceDoc.styleSheets).map(x => x as CSSStyleSheet).forEach(styleSheet => {
    if (styleSheet.cssRules) { // for <style> elements
      const newStyleEl = sourceDoc.createElement('style');

      Array.from(styleSheet.cssRules).forEach(cssRule => {
        // write the text of each rule into the body of the style element
        newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
      });

      targetDoc.head.appendChild(newStyleEl);
    } else if (styleSheet.href) { // for <link> elements loading CSS from a URL
      const newLinkEl = sourceDoc.createElement('link');

      newLinkEl.rel = 'stylesheet';
      newLinkEl.href = styleSheet.href;
      targetDoc.head.appendChild(newLinkEl);
    }
  });
}

